import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

//modules
import auth from "./modules/auth";
import product from "./modules/product";
import category from "./modules/category";
import customer from "./modules/customer";
import cart from "./modules/cart";
import notification from "./modules/notification";
import sale from "./modules/sale";
import stock from "./modules/stock";
import storekeeper from "./modules/storekeeper";
import seller from "./modules/seller";
import payment from "./modules/payment";
import credit from "./modules/credit";
import loadOrder from "./modules/loadOrder";
import loadOrderItem from "./modules/loadOrderItem";
import item from "./modules/item";

// Vuex plugin to inject $api into store instance
const apiPlugin = (store) => {
  // Create a proxy to access $api from Vue prototype
  // This works even if the axios plugin is installed after store creation
  Object.defineProperty(store, "$api", {
    get() {
      // Try Vue prototype first, fallback to _vm if available
      return Vue.prototype.$api || (store._vm && store._vm.$api) || null;
    },
    configurable: true,
  });
};

export default new Vuex.Store({
  state: {
    customer_type: {},
    customer: {},
  },
  mutations: {},
  actions: {},
  modules: {
    auth,
    category,
    customer,
    notification,
    product,
    cart,
    sale,
    stock,
    storekeeper,
    seller,
    payment,
    credit,
    loadOrder,
    loadOrderItem,
    item,
  },
  plugins: [apiPlugin],
});
